/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { generalEnvVars, publicBucketBaseUrl } from './env-vars'

const assetUrlsBase = 'assets'
export const urlBase = generalEnvVars.baseUrl
export const apiUriBase = generalEnvVars.apiUri
export const apiUrlBase = generalEnvVars.apiUri
export const filesThumbnailsBaseUrl = `${publicBucketBaseUrl}/defaults/file-type-thumbnails`
export const defaultThumbnailUrl = `${filesThumbnailsBaseUrl}/default-thumbnail.png`
export const filesTypeIconsBaseUrl = `${publicBucketBaseUrl}/defaults/file-type-icons`

export const assetsUrls = {
  base: 'assets',
  new: 'new',
  asset: ':assetId',
  single: '/single',
  makepreview: '/makepreview/:assetId',
  allLicenseHistory: ':assetId/all-license-history',
  assetForm: 'asset-form'
}

export const assetsBatchesUrls = {
  base: 'register-multiple-assets',
  create: 'create',
  batch: ':batchId'
}

export const listMultipleAssetsUrls = {
  base: 'list-multiple-assets',
  create: 'create',
  batch: ':batchId'
}

export const assetUrls = {
  base: assetUrlsBase,
  asset: ':workId',
  new: 'new',
  listMultipleWorks: 'list-multiple-works'
}

export const urlsGeneral = {
  base: '/',
  licenses: 'licenses',
  collections: 'assets',
  account: 'account',
  login: 'login',
  logout: 'logout',
  sats: 'sats',
  offers: 'offers',
  agreement: 'agreement',
  works: assetUrlsBase
}

export const userUrls = {
  account: 'account',
  login: 'login',
  logout: 'logout'
}

export const organizationUrls = {
  base: 'organization'
}

export const thumbnailUrlsByFileType = {
  audio: `${filesThumbnailsBaseUrl}/default-audio.png`,
  video: `${filesThumbnailsBaseUrl}/default-video.png`,
  image: `${filesThumbnailsBaseUrl}/default-image.png`,
  document: `${filesThumbnailsBaseUrl}/default-thumbnail.png`,
  unknown: `${filesThumbnailsBaseUrl}/default-unknown.png`
}

export const iconUrlsByFileType = {
  audio: `${filesTypeIconsBaseUrl}/default-audio-icon.png`,
  video: `${filesTypeIconsBaseUrl}/default-video-icon.png`,
  image: `${filesTypeIconsBaseUrl}/default-image-icon.png`,
  document: `${filesTypeIconsBaseUrl}/default-document-icon.png`,
  unknown: `${filesTypeIconsBaseUrl}/default-unknown-icon.png`
}

export const samsUrls = {
  base: 'sams',
  sam: ':samId'
}

export const manageSamListingsUrls = {
  base: 'manage-sam-listings',
  sams: ':manageId'
}

export const pendingSamsUrls = {
  base: 'pending-sams'
}

export const samsBuildBatchesUrls = {
  base: 'sams-build-batches',
  batch: ':batchId',
  create: 'create'
}
